import { render, staticRenderFns } from "./SelectImportTemplate.vue?vue&type=template&id=4bed4d40&scoped=true"
import script from "./SelectImportTemplate.vue?vue&type=script&lang=js"
export * from "./SelectImportTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bed4d40",
  null
  
)

export default component.exports